import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import NewNavbar from "../../new-components/NewNavbar";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import { addToCart, receiveProducts } from "../../store/actions/action";
import ProductSidebar from "./sidebar";
import ShopProduct from "../../components/ShopProduct";
import axios from "axios";

const ShopPage = ({ addToCart, receiveProducts }) => {
  // const productsArray = api();
  const [products, setProducts] = useState();

  const fetchData = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_BASE}/product/get`,
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
        },
      }
    );
    setProducts(result.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const addToCartProduct = (product, qty = 1) => {
    addToCart(product, qty);
  };

  // const products = productsArray;

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />


      <NewPageHeader />
      <section className="wpo-shop-page section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 order-lg-2">
              <ShopProduct
                addToCartProduct={addToCartProduct}
                products={products}
              />
            </div>
            <ProductSidebar
              addToCartProduct={addToCartProduct}
              products={products}
            />
          </div>
        </div>
      </section>
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default connect(null, { addToCart, receiveProducts })(ShopPage);
